import { noop } from "lodash-es";
import { createContext } from "react";

import type { CreateMenuAction } from "./CreateMenu";

export const CreateMenuContext = createContext<{
  action: CreateMenuAction | null;
  setAction: React.Dispatch<CreateMenuAction>;
}>({
  action: null,
  setAction: noop,
});
